import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as RightArrow } from "../assets/images/icon/gray-arrow-right.svg";
import { accordianList } from "../../src/data/faq/accordianList";
import CustomLink from "../components/Common/CustomLink";
import Accordian from "../components/Accordion";
const Careers = () => {
    const [openedAccordian, setOpenedAccordian] = useState(false);
    const [isExpandAccordian, setIsExpandAccoridan] = useState(false);
    const handleOpenClose = (id) => {
        if (id === openedAccordian) {
            setOpenedAccordian(null);
        } else {
            setOpenedAccordian(id);
        }
    };
    return (
        <div className="careers-section">
            <div className="careers-section-wrap">
                <div className="container">
                    <div className="section-title">
                        <h2>Careers at Digialpha</h2>
                        <h3>Join a team and inspire the work</h3>
                        <div className="content">
                            <p>Digialpha is a place where individual imaginations gather together, committing to the values that lead to great work.</p>
                            <p> Here, you'll do more than join something - you’ll match your ingenuity with the latest technology to build extraordinary things that makes an impact.</p>
                            <p>Explore remote-friendly, flexible opportunities and join our purpose to make positive contributions to the society through technology.</p>
                        </div>
                    </div>
                    <div className="accordion-wrapper">
                        {/* <div className="accordion">
                            {accordianList.map((faq, index) => {
                                return <Accordian
                                    handleOpenClose={handleOpenClose}
                                    openedAccordian={openedAccordian}
                                    id={index}
                                    key={"FAQ" + index}
                                    title={faq.title}
                                    content={faq.description}
                                    button={faq.button}
                                    className={`card-content-wrap`}
                                />
                            })}

                        </div> */}

                        <div className="explore-btn">
                            <CustomLink to="/careers" renderSvg={true}>
                                <h5>Find Your Perfect Role</h5>
                            </CustomLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Careers;
